import { getLocalizationInfo } from 'project.config';
import useI18n from '../useI18n';

export const useResolvedLocalizedObject = (localized: object | string) => {
  const { locale: nextLocale } = useI18n();

  const { locale } = getLocalizationInfo(nextLocale);

  return localized[locale as keyof typeof localized] ?? localized ?? '';
};
